import React from 'react'
import styles from './PageTabs.css'

const PageTabs = props =>
  (
    <div className={styles.pageTabs}>
      {props.children}
    </div>
  )

export default PageTabs



// WEBPACK FOOTER //
// ./src/legacy/components/PageTabs/PageTabs.jsx